// https://medium.com/@Jaimayal/how-to-properly-manage-search-params-in-nextjs-app-router-leverage-the-power-of-nuqs-the-right-way-9f7238cff76a
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import { Options, useQueryState } from "nuqs";

interface SearchParamStateOptions extends Options {
  defaultValue?: string | null;
}

export const useSearchParamState = (
  key: URLSearchParamKeys,
  options = {} as SearchParamStateOptions
): [
    string | null,
  (value: string | null) => void,
  () => void
] => {
  const { defaultValue = null, ...restOptions } = options;

  const [value, setValue] = useQueryState(
    key,
    {
      history: 'push',
      shallow: true,
      clearOnDefault: true,
      defaultValue: '',
      ...restOptions
    }
  )

  const unsetSearchParam = () => {
    console.log(`unsetSearchParam: ${key}`)
    setValue('');
  };

  const currentValue = value === '' && typeof defaultValue !== "undefined" ? defaultValue : value;

  return [
    currentValue,
    setValue,
    unsetSearchParam
  ];
};